import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dashboard-connect-help-dialog',
  templateUrl: './dashboard-connect-help-dialog.component.html',
  styleUrls: ['./dashboard-connect-help-dialog.component.scss']
})
export class DashboardConnectHelpDialogComponent {
  constructor(private readonly dialogRef: MatDialogRef<DashboardConnectHelpDialogComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}


